import { Navigate } from "react-router-dom";

import { useEnableOrbac } from "featureFlags/hooks/useEnableOrbac";
import { useHasAccountAdminRole } from "services/auth/useHasAccountAdminRole";
import { useHasAdminRole } from "services/auth/useHasAdminRole";

export const adminRestricted = ({
  OrganizationAdminComponent,
  AccountAdminComponent,
}: {
  OrganizationAdminComponent: React.ComponentType;
  AccountAdminComponent: React.ComponentType;
}) => {
  return (props: React.ComponentProps<typeof OrganizationAdminComponent>) => {
    const hasOrganizationAdminRole = useHasAdminRole();
    const { hasAccountAdminRole } = useHasAccountAdminRole();
    const enabledOrbac = useEnableOrbac();

    if (hasOrganizationAdminRole || enabledOrbac) {
      return <OrganizationAdminComponent {...props} />;
    }
    if (hasAccountAdminRole && !enabledOrbac) {
      return <AccountAdminComponent {...props} />;
    }
    return <Navigate to="/" />;
  };
};
